import { Component } from '@angular/core';

@Component({
  selector: 'ngx-jobs',
  template: `<router-outlet></router-outlet>`,
})
export class JobsComponent {
}
